/* Stormrock · accueil, entête et pied de page du nouveau design
 * Cartes produit (formats, ajout au panier), comptes à rebours, points des carrousels, menu mobile,
 * boutons panier (ouverture du tiroir + pastille), FAQ, avis Trustpilot en direct.
 */
(() => {
  if (window.SRHome) return;
  const q = (s, r) => (r || document).querySelector(s);
  const qa = (s, r) => Array.from((r || document).querySelectorAll(s));
  const NB = ' ';
  const isDesk = () => window.matchMedia('(min-width: 990px)').matches;
  function eur(cents) {
    const v = Math.max(0, Math.round(cents)) / 100;
    let [i, d] = v.toFixed(2).split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, NB) + ',' + d + NB + '€';
  }
  const ready = (f) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', f) : f());

  /* ---------- cartes ---------- */
  function initCard(card) {
    if (card.dataset.srhReady) return;
    card.dataset.srhReady = '1';
    const fts = qa('.k-ft', card);
    const price = q('[data-srh-kprice]', card);
    const save = q('[data-srh-ksave]', card);
    const pick = (btn) => {
      fts.forEach((x) => { const on = x === btn; x.classList.toggle('k-on', on); x.setAttribute('aria-pressed', on); });
      if (price) price.textContent = btn ? eur(+btn.dataset.price) : '';
      /* offre : prix barré, économie et stock restant du format choisi */
      if (save) {
        const c = btn ? +btn.dataset.cmp || 0 : 0;
        const p = btn ? +btn.dataset.price || 0 : 0;
        const st = btn && btn.dataset.stock !== undefined ? +btn.dataset.stock : -1;
        let h = '';
        if (c > p && !('nowas' in save.dataset)) h += '<span class="k-sv1">' + (save.dataset.was || 'Au lieu de') + ' <s>' + eur(c) + '</s></span><span class="k-sv2">' + (save.dataset.lab || 'Économie') + ' ' + eur(c - p) + '</span>';
        if (st > 0 && st <= (+save.dataset.low || 0)) h += '<span class="k-sv3"><i></i>' + (save.dataset.stockLab || 'Plus que [n] en stock').replace('[n]', st) + '</span>';
        save.innerHTML = h;
        save.hidden = !h;
      }
    };
    const ok = fts.filter((b) => !b.disabled);
    pick(q('.k-ft[data-def="1"]:not([disabled])', card) || ok[Math.min(3, ok.length - 1)] || null);
    fts.forEach((b) => b.addEventListener('click', () => { if (!b.disabled) pick(b); }));
    const add = q('[data-srh-add]', card);
    if (add) add.addEventListener('click', () => {
      const btn = q('.k-ft.k-on', card);
      if (!btn || add.disabled) return;
      const go = window.SRProduct && window.SRProduct.add;
      const o = { id: btn.dataset.variant, cents: +btn.dataset.price, title: add.dataset.title, variant: q('b', btn).textContent, img: add.dataset.img, button: add };
      if (go) go(o);
      else fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +o.id, quantity: 1 }] }) })
        .then(() => document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'sr-home' } } })));
    });
    const heart = q('[data-srh-heart]', card);
    if (heart) {
      const key = 'srp_fav_' + heart.dataset.srhHeart;
      let on = false; try { on = localStorage.getItem(key) === '1'; } catch (e) { /* ignore */ }
      heart.setAttribute('aria-pressed', on);
      heart.addEventListener('click', () => { on = !on; heart.setAttribute('aria-pressed', on); try { on ? localStorage.setItem(key, '1') : localStorage.removeItem(key); } catch (e) { /* ignore */ } });
    }
    const vid = q('video.k-alt', card);
    if (vid) {
      const hero = q('.k-hero', card);
      hero.addEventListener('mouseenter', () => { if (!isDesk()) return; if (!vid.src) vid.src = vid.dataset.src; card.classList.add('k-play'); vid.play().catch(() => {}); });
      hero.addEventListener('mouseleave', () => { card.classList.remove('k-play'); try { vid.pause(); } catch (e) { /* ignore */ } });
    }
  }

  /* ---------- points des carrousels (mobile) ---------- */
  function initDots(dots) {
    if (dots.dataset.srhReady) return;
    dots.dataset.srhReady = '1';
    const rail = dots.previousElementSibling;
    if (!rail) return;
    const slots = Array.from(rail.children);
    if (slots.length < 2) { dots.hidden = true; return; }
    dots.innerHTML = slots.map((_, i) => '<i' + (i === 0 ? ' class="on"' : '') + '></i>').join('');
    const is = Array.from(dots.children);
    const sync = () => {
      const x = rail.scrollLeft;
      let k = 0, best = 1e9;
      slots.forEach((s, i) => { const d = Math.abs(s.offsetLeft - rail.firstElementChild.offsetLeft - x); if (d < best) { best = d; k = i; } });
      if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) k = slots.length - 1;
      is.forEach((d, i) => d.classList.toggle('on', i === k));
    };
    rail.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
  }

  /* ---------- comptes à rebours ---------- */
  const timers = [];
  /* « AAAA-MM-JJTHH:MM » lu à l'heure de Paris */
  function parisMs(raw) {
    const m = (raw || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{1,2}):(\d{2})/);
    if (!m) return NaN;
    const local = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    const off = (() => { try {
      const p = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Paris', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date(local));
      const g = (t) => +p.find((x) => x.type === t).value;
      return Date.UTC(g('year'), g('month') - 1, g('day'), g('hour') % 24, g('minute')) - local;
    } catch (e) { return 3600000; } })();
    return local - off;
  }
  function initTimer(el) {
    if (el.dataset.srhReady) return;
    el.dataset.srhReady = '1';
    /* début + durée (ex. 48 h) ou date de fin fixe */
    const start = parisMs(el.dataset.srhStart);
    const hours = +el.dataset.srhHours || 0;
    let end = parisMs(el.dataset.srhEnd);
    if (!isNaN(start) && hours > 0) end = start + hours * 3600000;
    if (isNaN(end)) return;
    const sm = q('small', el);
    timers.push({ el, end, start: isNaN(start) ? 0 : start, loop: el.dataset.srhLoop === '1', lab: sm ? sm.textContent : '', prog: q('[data-srh-prog]', el) });
  }
  const pad = (n) => String(n).padStart(2, '0');
  function tick() {
    const now = Date.now();
    timers.forEach((t) => {
      /* en boucle : le compte à rebours repart de la durée complète à chaque fin de cycle (même cycle pour tous les visiteurs) */
      if (t.loop && t.start && now >= t.end) {
        const per = t.end - t.start;
        if (per > 0) { const k = Math.floor((now - t.start) / per); t.start += k * per; t.end = t.start + per; }
      }
      const st = t.start && now < t.start ? 'pre' : (now >= t.end ? 'over' : 'on');
      let s = Math.max(0, Math.floor(((st === 'pre' ? t.start : t.end) - now) / 1000));
      const hms = t.el.dataset.srhFmt === 'hms';
      const d = hms ? 0 : Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const mi = Math.floor(s / 60); s -= mi * 60;
      const v = { d: pad(d), h: pad(h), m: pad(mi), s: pad(s) };
      qa('[data-u]', t.el).forEach((u) => { u.textContent = v[u.dataset.u]; });
      if (t.prog && t.start) t.prog.style.transform = 'scaleX(' + (st === 'on' ? Math.max(0, Math.min(1, (t.end - now) / (t.end - t.start))) : (st === 'pre' ? 1 : 0)).toFixed(4) + ')';
      if (t.st === st) return;
      t.st = st;
      t.el.dataset.state = st;
      const sm = q('small', t.el);
      if (sm) sm.textContent = st === 'pre' ? (t.el.dataset.srhBefore || t.lab) : (st === 'over' ? (t.el.dataset.srhExpired || t.lab) : t.lab);
      /* offre terminée : la section disparaît (sauf dans l'éditeur de thème) */
      if (st === 'over' && t.el.dataset.srhHide === '1' && !(window.Shopify && window.Shopify.designMode)) {
        const sec = t.el.closest('.shopify-section');
        if (sec) sec.style.display = 'none';
      }
    });
  }

  /* ---------- entête : panier, pastille, menu mobile ---------- */
  function setCount(n) {
    qa('[data-srh-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
  }
  function readCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => setCount(c.item_count || 0)).catch(() => {});
  }
  let cTimer = 0;
  document.addEventListener('cart:update', (e) => {
    const n = e && e.detail && e.detail.data && e.detail.data.itemCount;
    if (typeof n === 'number') setCount(n);
    clearTimeout(cTimer); cTimer = setTimeout(readCount, 400);
  });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-srh-cart]');
    if (!a) return;
    const dr = q('cart-drawer-component');
    if (dr && typeof dr.open === 'function') { e.preventDefault(); noReopenUntil = 0; try { dr.open(); } catch (err) { location.href = a.href; } }
  });

  /* ---------- tiroir panier : la poubelle retire le produit sans fermer le panier ;
     au dernier produit, le panier se ferme et ne se rouvre pas tout seul ---------- */
  let keepOpen = false, lastRemove = 0, noReopenUntil = 0;
  function guardDrawer() {
    const dr = q('cart-drawer-component');
    if (!dr || dr.__srGuard || typeof dr.closeDialog !== 'function') return;
    dr.__srGuard = true;
    const close0 = dr.closeDialog, show0 = dr.showDialog;
    dr.closeDialog = function () { if (keepOpen) return Promise.resolve(); return close0.apply(this, arguments); };
    // le thème rouvre le panier à chaque mise à jour : bloqué juste après avoir vidé le panier
    dr.showDialog = function () { if (Date.now() < noReopenUntil) return; return show0.apply(this, arguments); };
  }
  function closeEmptied() {
    noReopenUntil = Date.now() + 6000;
    keepOpen = false;
    const dr = q('cart-drawer-component');
    if (dr && typeof dr.close === 'function') dr.close();
  }
  window.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const dr = t.closest('cart-drawer-component');
    if (!dr) {
      // l'utilisateur ouvre le panier ou ajoute un produit : le panier peut de nouveau s'ouvrir
      if (t.closest('[data-srh-cart], [data-srh-add], [data-srp-add], .k-cta, button[name="add"], [type="submit"], .cart-icon, [href$="/cart"]')) noReopenUntil = 0;
      return;
    }
    guardDrawer();
    const dlg = q('dialog', dr);
    // clic à l'intérieur d'une ligne du panier (poubelle, quantité…) : jamais une fermeture
    if (dlg && dlg.contains(t) && t.closest('.cart-form, [ref="cartItemRows[]"]') && !t.closest('[on\\:click*="close"], .cart-drawer__close-button')) {
      keepOpen = true;
      setTimeout(() => { keepOpen = false; }, 0);
      if (t.closest('button.rm, [on\\:click*="onLineItemRemove"]')) {
        lastRemove = Date.now();
        // dernier produit du panier : on ferme tout de suite (la suppression continue en arrière-plan)
        const left = qa('button.rm', dlg).filter((x) => x.getClientRects().length).length;
        if (left <= 1) setTimeout(closeEmptied, 120);
      }
    }
  }, true);
  document.addEventListener('submit', () => { noReopenUntil = 0; }, true);
  document.addEventListener('cart:update', () => {
    if (!lastRemove || Date.now() - lastRemove > 8000) return;
    clearTimeout(window.__srEmptyT);
    window.__srEmptyT = setTimeout(() => {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => {
        const paid = (c.items || []).filter((it) => (it.final_line_price || 0) > 0);
        if (!paid.length) { lastRemove = 0; closeEmptied(); }
      }).catch(() => {});
    }, 350);
  });


  /* ---------- méga menu (ordinateur) : panneau de vignettes au survol, au clavier et au toucher ---------- */
  function initMega(h) {
    const mm = q('[data-srh-mega]', h), veil = q('[data-srh-mega-veil]', h);
    if (!mm || mm.dataset.srhReady) return;
    mm.dataset.srhReady = '1';
    const header = mm.closest('header');
    const items = qa('.nav .it[data-mm-k]', header);
    if (!items.length) return;
    let cur = null, t = 0;
    const panel = (k) => q('[data-mm-p="' + k + '"]', mm);
    function place() {
      const hb = header.getBoundingClientRect(), z = hb.width / (header.offsetWidth || hb.width) || 1;
      const first = items[0].getBoundingClientRect();
      let left = (first.left - hb.left) / z - 24;
      const W = header.offsetWidth;
      const width = Math.min(1183, W - 48);
      left = Math.max(24, Math.min(left, W - width - 24));
      mm.style.left = left + 'px'; mm.style.width = width + 'px';
    }
    function open(it) {
      clearTimeout(t);
      const k = it.dataset.mmK, p = panel(k);
      if (!p) return;
      if (cur && cur !== it) { cur.removeAttribute('data-mm-open'); const a = q('a', cur); if (a) a.setAttribute('aria-expanded', 'false'); const op = panel(cur.dataset.mmK); if (op) op.removeAttribute('data-on'); }
      cur = it; place();
      it.setAttribute('data-mm-open', ''); const a = q('a', it); if (a) a.setAttribute('aria-expanded', 'true');
      p.setAttribute('data-on', ''); mm.setAttribute('data-on', ''); mm.setAttribute('aria-hidden', 'false');
      if (veil) veil.setAttribute('data-on', '');
    }
    function close() {
      clearTimeout(t);
      if (!cur) return;
      cur.removeAttribute('data-mm-open'); const a = q('a', cur); if (a) a.setAttribute('aria-expanded', 'false');
      const p = panel(cur.dataset.mmK); if (p) p.removeAttribute('data-on');
      cur = null; mm.removeAttribute('data-on'); mm.setAttribute('aria-hidden', 'true');
      if (veil) veil.removeAttribute('data-on');
    }
    const later = () => { clearTimeout(t); t = setTimeout(close, 160); };
    items.forEach((it) => {
      it.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'touch') open(it); });
      it.addEventListener('pointerleave', (e) => { if (e.pointerType !== 'touch') later(); });
      it.addEventListener('focusin', () => open(it));
      const a = q('a', it);
      // au toucher (tablette) : 1er appui = ouvre le panneau, 2e appui = va à la collection
      if (a) a.addEventListener('click', (e) => { if (cur !== it && window.matchMedia('(hover: none)').matches) { e.preventDefault(); open(it); } });
    });
    // dès que la souris approche du menu : on charge les vignettes (pas de cases blanches à l'ouverture)
    const warm = () => { qa('img[loading="lazy"]', mm).forEach((i) => { i.loading = 'eager'; }); };
    const nav = q('.nav', header); if (nav) nav.addEventListener('pointerenter', warm, { once: true });
    items.forEach((it) => it.addEventListener('focusin', warm, { once: true }));
    mm.addEventListener('pointerenter', () => clearTimeout(t));
    mm.addEventListener('pointerleave', later);
    if (veil) { veil.addEventListener('pointerenter', later); veil.addEventListener('click', close); }
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && cur) { const a = q('a', cur); close(); if (a) a.focus(); } });
    document.addEventListener('focusin', (e) => { if (cur && !header.contains(e.target)) close(); });
    window.addEventListener('resize', () => { if (cur) place(); });
    let y0 = window.scrollY;
    window.addEventListener('scroll', () => { if (cur && Math.abs(window.scrollY - y0) > 60) close(); if (!cur) y0 = window.scrollY; }, { passive: true });
  }

  function initMenu(root) {
    const mm = q('[data-srh-mm]', root), burger = q('[data-srh-burger]', root);
    if (!mm || !burger || mm.dataset.srhReady) return;
    mm.dataset.srhReady = '1';
    document.body.appendChild(mm);
    const open = (o) => {
      mm.classList.toggle('open', o); mm.setAttribute('aria-hidden', !o);
      burger.setAttribute('aria-expanded', o);
      document.documentElement.classList.toggle('srh-lock', o);
      if (o) { const x = q('.x', mm); if (x) x.focus(); } else burger.focus();
    };
    burger.addEventListener('click', () => open(true));
    qa('[data-srh-mm-close]', mm).forEach((b) => b.addEventListener('click', () => open(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && mm.classList.contains('open')) open(false); });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    qa('.qa', root).forEach((qa_) => {
      if (qa_.dataset.srhReady) return;
      qa_.dataset.srhReady = '1';
      const b = q('.q', qa_);
      b.addEventListener('click', () => { const o = qa_.classList.toggle('open'); b.setAttribute('aria-expanded', o); });
    });
  }

  /* ---------- Trustpilot ---------- */
  const TPL = '539adbd6dec7e10e686debee';
  const tpCache = {};
  function tpData(bu, n) {
    const k = bu + ':' + n;
    if (tpCache[k]) return tpCache[k];
    let cached = null;
    try { const c = JSON.parse(sessionStorage.getItem('srh_tp_' + k) || 'null'); if (c && Date.now() - c.t < 30 * 60000) cached = c.d; } catch (e) { /* ignore */ }
    if (cached) return (tpCache[k] = Promise.resolve(cached));
    const url = 'https://widget.trustpilot.com/trustbox-data/' + TPL + '?businessUnitId=' + encodeURIComponent(bu) + '&locale=fr-FR&reviewLanguages=fr&reviewStars=5&reviewsPerPage=' + n;
    return (tpCache[k] = fetch(url).then((r) => (r.ok ? r.json() : Promise.reject(r.status))).then((d) => {
      try { sessionStorage.setItem('srh_tp_' + k, JSON.stringify({ t: Date.now(), d })); } catch (e) { /* ignore */ }
      return d;
    }));
  }
  const fmtN = (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, NB);
  const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  const fmtD = (iso) => { const d = new Date(iso); return isNaN(d) ? '' : d.getDate() + ' ' + MONTHS[d.getMonth()]; };
  function initHeaderTp(h) {
    if (h.dataset.srhReady) return;
    h.dataset.srhReady = '1';
    if (h.dataset.tpLive !== 'true' || !h.dataset.tpBu) return;
    tpData(h.dataset.tpBu, 8).then((d) => {
      const t = d && d.businessUnit && d.businessUnit.numberOfReviews && d.businessUnit.numberOfReviews.total;
      if (t) qa('[data-srh-tpcount]').forEach((x) => { x.textContent = fmtN(t); });
    }).catch(() => {});
  }
  function initReviews(sec) {
    if (sec.dataset.srhReady) return;
    sec.dataset.srhReady = '1';
    if (sec.dataset.live !== 'true' || !sec.dataset.bu) return;
    const n = +sec.dataset.count || 8, max = +sec.dataset.maxlen || 110;
    tpData(sec.dataset.bu, n).then((d) => {
      const bu = d.businessUnit || {};
      if (bu.numberOfReviews && bu.numberOfReviews.total) qa('[data-srh-tpn]', sec).forEach((x) => { x.textContent = fmtN(bu.numberOfReviews.total); });
      if (bu.stars) qa('[data-srh-tpr]', sec).forEach((x) => { x.textContent = String(bu.stars).replace('.', ','); });
      const list = (d.reviews || []).slice(0, n);
      if (!list.length) return;
      const tpl = q('template[data-srh-tptpl]', sec);
      if (!tpl) return;
      const cardT = tpl.content.querySelector('.tp-card'), starT = tpl.content.querySelector('.tp-s');
      qa('[data-srh-tpgrid]', sec).forEach((grid) => {
        const frag = document.createDocumentFragment();
        list.forEach((r) => {
          const c = cardT.cloneNode(true);
          const st = q('.tp-stars', c);
          for (let i = 0; i < (r.stars || 5); i++) st.appendChild(starT.cloneNode(true));
          const v = r.verification || {};
          const kind = v.isVerified ? 'verified' : /redirect/i.test((v.verificationSource || '') + (v.reviewSource || '')) ? 'redirect' : '';
          qa('.tp-b', c).forEach((b) => { b.hidden = b.dataset.b !== kind; if (b.hidden) b.remove(); });
          q('.tp-who b', c).textContent = ((r.consumer && r.consumer.displayName) || 'Client') + ',';
          q('.tp-who span', c).textContent = fmtD(r.createdAt);
          let ttl = (r.title || '').trim();
          let txt = (r.text || '').trim();
          // avis dont le titre reprend simplement le début du texte : on n'affiche pas deux fois la même phrase
          const bare = ttl.replace(/(\.\.\.|…)$/, '').trim().toLowerCase();
          if (bare && txt.toLowerCase().startsWith(bare)) { if (txt.length - bare.length < 4) txt = ''; else ttl = ''; }
          q('.tp-t', c).textContent = ttl; q('.tp-t', c).hidden = !ttl;
          const long = txt.length > max;
          if (long) txt = txt.slice(0, max).replace(/\s+\S*$/, '') + '…';
          q('.tp-txt', c).textContent = txt;
          const rep = r.companyReply || r.reply;
          const rp = q('.tp-reply', c);
          if (rep && (rep.createdAt || rep.text)) { rp.hidden = false; q('.tp-reply-d', rp).textContent = fmtD(rep.createdAt || r.createdAt); } else rp.remove();
          const more = q('.tp-more', c);
          if (long && r.reviewUrl) { more.hidden = false; more.href = r.reviewUrl; } else more.remove();
          frag.appendChild(c);
        });
        grid.replaceChildren(frag);
        if (grid.scrollLeft) grid.scrollLeft = 0;
      });
    }).catch(() => {});
  }


  /* ---------- header : se cache quand on descend, revient dès qu'on remonte ---------- */
  function initHeaderScroll(h) {
    if (h.dataset.srhScroll) return;
    h.dataset.srhScroll = '1';
    /* Règle anti-clignotement :
       - pour réapparaître : remonter d'au moins 70 px (mesuré depuis le point le plus bas atteint) ;
       - pour disparaître : redescendre d'au moins 140 px (mesuré depuis le point le plus haut atteint) ;
       - une fois affiché ou caché, il reste dans cet état au moins 2 s, sauf geste franc (≥ 450 px) ;
       - tout en haut de la page, il est toujours là. */
    const SHOW_AFTER = 70, HIDE_AFTER = 140, HOLD_MS = 2000, FORCE = 450;
    let ticking = false, maxY = 0, minY = 0, since = 0;
    const roots = () => qa('.srh.srh-hd', h).filter((r) => r.getClientRects().length);
    function setShown(on) {
      h.classList.toggle('show', on);
      since = performance.now();
      maxY = minY = window.scrollY;
    }
    function measure() {
      h.classList.remove('fx', 'show', 'anim');
      h.style.minHeight = '';
      const r = roots()[0];
      h.__hh = r ? r.getBoundingClientRect().height : 0;
      h.__top = h.getBoundingClientRect().top + window.scrollY;
      h.style.minHeight = h.__hh ? h.__hh + 'px' : '';
      maxY = minY = window.scrollY; since = 0;
      update();
    }
    function update() {
      ticking = false;
      const y = window.scrollY;
      if (document.documentElement.classList.contains('srh-lock') || document.body.style.position === 'fixed') return;
      const top = h.__top || 0, end = top + (h.__hh || 0);
      // haut de page : header à sa place normale
      if (y <= top + 1) { h.classList.remove('fx', 'show', 'anim'); maxY = minY = y; since = 0; return; }
      if (!h.classList.contains('fx')) {
        if (y > end) { h.classList.add('fx'); requestAnimationFrame(() => h.classList.add('anim')); maxY = minY = y; since = performance.now(); }
        return;
      }
      const shown = h.classList.contains('show');
      const held = performance.now() - since < HOLD_MS;
      if (shown) {
        minY = Math.min(minY, y);
        const down = y - minY;
        if (y > end && down >= HIDE_AFTER && (!held || down >= FORCE)) setShown(false);
      } else {
        maxY = Math.max(maxY, y);
        const up = maxY - y;
        if (up >= SHOW_AFTER && (!held || up >= FORCE)) setShown(true);
        // de retour dans la zone du header : il reprend sa place normale (jamais d'espace vide en haut)
        else if (y <= end) { h.classList.remove('fx', 'anim'); maxY = minY = y; }
      }
    }
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', () => { clearTimeout(h.__rt); h.__rt = setTimeout(measure, 150); });
    if (document.readyState === 'complete') measure(); else window.addEventListener('load', measure);
    measure();
  }

  /* ---------- bannière vidéo : seule la vidéo visible (ordinateur ou mobile) est chargée ---------- */
  /* la vidéo ne démarre qu'une fois la page chargée (l'image fixe s'affiche avant) ; jamais en économie de données
     ou en connexion très lente : seule l'image fixe reste */
  let pageLoaded = document.readyState === 'complete';
  if (!pageLoaded) window.addEventListener('load', () => { pageLoaded = true; setTimeout(initVideos, 150); }, { once: true });
  function initVideos() {
    if (!pageLoaded) return;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const cn = navigator.connection || {};
    if (cn.saveData || /(^|-)2g$/.test(cn.effectiveType || '')) return;
    qa('video[data-srh-v]').forEach((v) => {
      if (v.dataset.on || !v.getClientRects().length || calm) return;
      v.dataset.on = '1';
      v.src = v.dataset.srhV;
      v.muted = true;
      const p = v.play(); if (p && p.catch) p.catch(() => {});
    });
  }
  window.addEventListener('resize', () => { clearTimeout(window.__srhVT); window.__srhVT = setTimeout(initVideos, 200); });

  function boot(scope) {
    const r = scope || document;
    qa('[data-srh-card]', r).forEach(initCard);
    qa('[data-srh-dots]', r).forEach(initDots);
    qa('[data-srh-end]', r).forEach(initTimer);
    qa('[data-srh-header]', r).forEach((h) => { initMenu(h); initHeaderTp(h); initHeaderScroll(h); initMega(h); });
    guardDrawer();
    qa('[data-srh-faq]', r).forEach(initFaq);
    qa('[data-srh-reviews]', r).forEach(initReviews);
    initVideos();
    tick();
  }
  window.SRHome = { boot };
  ready(() => { boot(); setInterval(tick, 1000); });
  document.addEventListener('shopify:section:load', (e) => setTimeout(() => boot(e.target), 30));
})();
